export default {
  'ai.msg.domain.responses.core.Text': ['TextResponse'],
  'ai.msg.domain.responses.core.Image': ['ImageResponse'],
  'ai.msg.domain.responses.core.Video': ['VideoResponse'],
  'ai.msg.domain.responses.core.Card': ['ButtonCardResponse'],
  'ai.msg.domain.responses.core.Carousel': ['CarouselResponse'],
  'ai.msg.domain.responses.core.Audio' : ['AudioResponse'],
  'ai.msg.domain.responses.core.MessageInfoAttachment': [
    'HumanHandoffForm',
    'EmbeddedForm',
    'SchemaForm',
    'SurveyForm',
    'LLMSchemaForm'
  ],
  'ai.msg.domain.responses.core.GenericFileAttachment': ['FileAttachment'],
  'ai.msg.domain.responses.core.MultiSource': ['MultiSource'],
  'ai.msg.domain.responses.core.NBAAttachment': ['NBAAttachment'],
  'ai.msg.domain.formBuilder.Form': ['LLMSchemaForm'],
  'ai.msg.domain.responses.core.Email': ['EmailResponse'],
  'ai.msg.domain.responses.core.FillerText': ['FillerText'],
  'ai.msg.domain.responses.core.SecureForm': ['SecureForm']
}
